<template>
  <div>
    <FeatureConfigPanel
      :features="features"
      :feature-id="featureId"
      :label="label"
    />

    <div v-if="features[featureId].active" class="card tw-mt-3">
      <div class="card-header">{{ trans(tKey("tools_header")) }}</div>
      <div class="card-body">
        <span
          v-tooltip="
            hasUnsavedChanges ? trans('feature.cima.unsaved_changes') : null
          "
          class="cima-sync-btn-wrapper"
        >
          <button
            class="btn btn-primary"
            type="button"
            :disabled="hasUnsavedChanges"
            @click="open = true"
          >
            {{ trans("feature.cima.user_sync") }}
          </button>
        </span>
      </div>
    </div>

    <CimaUserSyncModal
      :open="open"
      :center-id="center.id"
      :integration="integration"
      :translation-prefix="translationPrefix"
      @close="open = false"
    />
  </div>
</template>

<script>
import FeatureConfigPanel from "./FeatureConfigPanel.vue";
import CimaUserSyncModal from "./CimaUserSyncModal.vue";

export default {
  components: { FeatureConfigPanel, CimaUserSyncModal },
  props: {
    features: Object,
    featureId: [String, Number],
    label: String,
    center: Object,
    saved: { type: Number, default: 0 },
    integration: { type: String, required: true },
    translationPrefix: { type: String, required: true },
  },
  data() {
    return {
      open: false,
      savedSnapshot: null,
    };
  },
  computed: {
    hasUnsavedChanges() {
      if (!this.savedSnapshot) return false;
      const current = this.currentSnapshot();
      return JSON.stringify(current) !== JSON.stringify(this.savedSnapshot);
    },
  },
  watch: {
    saved() {
      this.saveSnapshot();
    },
  },
  mounted() {
    this.saveSnapshot();
  },
  methods: {
    tKey(suffix) {
      return this.translationPrefix + "." + suffix;
    },
    saveSnapshot() {
      this.savedSnapshot = this.currentSnapshot();
    },
    currentSnapshot() {
      const feature = this.features[this.featureId];
      return {
        active: feature.active,
        config: JSON.parse(JSON.stringify(feature.config || {})),
      };
    },
  },
};
</script>
